import {
  AppBar,
  Dialog,
  DialogContent,
  IconButton,
  Toolbar
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { withStyles } from '@material-ui/styles';
import React from 'react';
import { pdfjs } from 'react-pdf';
import { Typography } from '../admin/components/Wrappers/Wrappers';

pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/pdf.worker.js`;

const styles = theme => ({
  appBar: {
    position: 'relative'
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1
  }
});

const DialogTitle = withStyles(styles)(props => {
  const { children, classes, onClose, downloadPdf, ...other } = props;
  return (
    <AppBar className={classes.appBar} {...other}>
      <Toolbar>
        {onClose ? (
          <IconButton
            edge="start"
            aria-label="close"
            color="inherit"
            onClick={onClose}
          >
            <CloseIcon />
          </IconButton>
        ) : null}
        <Typography variant="h6" className={classes.title}>
          {children}
        </Typography>
      </Toolbar>
    </AppBar>
  );
});

const Preview = ({ height, width, title, download, ...props }) => {
  return (
    <Dialog
      open={props.open}
      scroll="paper"
      fullWidth
      fullScreen
      aria-labelledby="customized-dialog-title"
      onClose={props.onClose}
    >
      <DialogTitle id="customized-dialog-title" onClose={props.onClose}>
        {title || 'Vista previa'}
      </DialogTitle>
      <DialogContent>{props.children}</DialogContent>
    </Dialog>
  );
};

export default Preview;
